export default "__VITE_ASSET__Sp72lmcb__"